import React, { createContext, useContext, useState, useEffect } from 'react';

const HistoriskFilterContext = createContext();

export const useHistoriskFilter = () => {
  const context = useContext(HistoriskFilterContext);
  if (!context) {
    throw new Error('useHistoriskFilter must be used within a HistoriskFilterProvider');
  }
  return context;
};

export const HistoriskFilterProvider = ({ children }) => {
  const [showHistorisk, setShowHistorisk] = useState(() => {
    // Load from localStorage on initialization, default to false (hide historisk files)
    const saved = localStorage.getItem('showHistorisk');
    return saved !== null ? JSON.parse(saved) : false;
  });

  useEffect(() => {
    // Save to localStorage whenever the state changes
    localStorage.setItem('showHistorisk', JSON.stringify(showHistorisk));
  }, [showHistorisk]);

  const toggleShowHistorisk = () => {
    setShowHistorisk(prev => !prev);
  };

  const filterFiles = (files) => {
    if (showHistorisk) {
      return files; // Show all files and folders
    }
    // Filter out historisk files but always show folders
    return files.filter(item => 
      item.ItemType === 'Folder' || // Always show folders
      item.Historisk === "False" || 
      item.Historisk === "0"
    );
  };

  const value = {
    showHistorisk,
    toggleShowHistorisk,
    filterFiles
  };

  return (
    <HistoriskFilterContext.Provider value={value}>
      {children}
    </HistoriskFilterContext.Provider>
  );
};